import React, { useCallback, useState } from 'react';
import Music from '../Music';

const MusicContainer = () => {
  return <Music />;
};

export default MusicContainer;
